import { ConversationMutation } from "../types";
import { Message } from "@/modules/staff/objects/conversation/Message";

export default {
  [ConversationMutation.SET_VOICE_TO_TEXT_ACTION](state: any, payload: any) {
    state.voiceToTextAction = payload;
  },
  [ConversationMutation.SET_SUBSCRIBED_UNREAD](state: any, payload: any) {
    state.subscribedUnreadMessage = payload;
  },
  [ConversationMutation.SET_PUSH_UNREAD](state: any, payload: any) {
    if (state.unreadMessageData.findIndex((element: any) => element.id === payload.id) >= 0) {
      return;
    }
    state.unreadMessageData.push(payload);
  },
  [ConversationMutation.SET_DELETE_UNREAD](state: any, payload: any) {
    state.unreadMessageData = state.unreadMessageData.filter((element: any) => element.id != payload);
  },
  [ConversationMutation.SET_LOAD_UNREAD](state: any, payload: any) {
    state.unreadMessageData = payload;
  },
  [ConversationMutation.SET_SUBSCRIPTIONS_ON_PAGE](state: any, payload: [any]) {
    state.subscriptionsOnPage = payload;
  },
  [ConversationMutation.SET_EVENT_DATA_LIST](state: any, payload: [any]) {
    state.eventDataList = payload;
  },
  [ConversationMutation.SET_HAS_STARTED_APPSYNC_SUBSCRIPTION](state: any, payload: [any]) {
    state.hasStartedAppSyncSubscription = payload;
  },
  [ConversationMutation.SET_UNSUBSCRIBE_ALL](state: any, payload: [any]) {
    state.unsubscribeAll = payload;
  },
  [ConversationMutation.SET_CURRENT_MESSAGES](state: any, payload: Message[]) {
    state.currentMessages = payload;
  },
  [ConversationMutation.START_VOICE_CHAT_IN_ROOM](state: any, payload: any) {
    state.voiceChatStartingAction = payload;
  },
  [ConversationMutation.RESPOND_VOICE_CHAT_IN_ROOM](state: any, payload: any) {
    state.voiceChatRespondAction = payload;
  },
  [ConversationMutation.SET_CURRENT_MESSAGES_WITH_STAFF](state: any, payload: Message[]) {
    state.currentMessagesWithStaff = payload;
  },
  [ConversationMutation.SET_CURRENT_CONVERSATION_ID](state: any, payload: string) {
    state.currentConversationId = payload;
  },
  [ConversationMutation.SET_CURRENT_CONVERSATION_ID_WITH_STAFF](state: any, payload: string) {
    state.currentConversationIdWithStaff = payload;
  },
  [ConversationMutation.SET_CURRENT_CONVERSATION_HIDE_CONTACT](state: any, payload: string) {
    state.currentConversationHideContact = payload;
  },
  [ConversationMutation.START_SUBSCRIPTION](state: any, payload: boolean) {
    state.startAppSyncSubscription = payload;
  },
  [ConversationMutation.SET_CONVERSATION_IDS](state: any, payload: string[]) {
    state.conversationIds = payload;
  },
  [ConversationMutation.CLEAR_CONVERSATION_IDS](state: any) {
    state.conversationIds = [];
  },
  [ConversationMutation.ADD_CONVERSATION_ID](state: any, payload: string) {
    if (state.conversationIds.findIndex((item: string) => item === payload) < 0) {
      state.conversationIds.push(payload);
    }
  },
  [ConversationMutation.ADD_SURVEY_SCORE](state: any, payload: { conversationId: string; score: string }) {
    state.conversationSurveyScores.push(payload);
  },
  [ConversationMutation.SET_SHOW_NEW_ICON](state: any, payload: boolean) {
    state.showNewIcon = payload;
  },
  [ConversationMutation.SET_IMPORTANCE](state: any, payload: boolean) {
    state.importance = payload;
  },
  [ConversationMutation.SET_FORWARD_INQUIRY_ID](state: any, payload: number) {
    state.forwardInquiryId = payload;
  },
  [ConversationMutation.SET_FROM_INQUIRY_HISTORY](state: any, payload: boolean) {
    state.fromInquiryHistory = payload;
  },
  [ConversationMutation.SET_IS_CONTACT_BUTTON_VIEW](state: any, payload: boolean) {
    state.isContactButtonView = payload;
  },
  [ConversationMutation.SET_NO_STAFF_CAN_RESPOND_VOICE_CHAT_NOTIFICATION](state: any, payload: boolean) {
    state.noStaffCanRespondVoiceChatNotification = payload;
  },
  [ConversationMutation.SET_TICKET_QUEUE_STOP_INQUIRY](state: any, payload: boolean) {
    state.ticketQueueStopInquiry = payload;
  },
  [ConversationMutation.SET_SHOW_GUEST_LOADING](state: any, payload: boolean) {
    state.showGuestLoading = payload;
  },
  [ConversationMutation.SET_RUNNING_ELLIPSE](state: any, payload: any) {
    if (!state.runningEllipse) {
      state.runningEllipse = [];
    }
    state.runningEllipse.push(payload);
  },
  [ConversationMutation.SET_GUEST_RUNNING_ELLIPSE](state: any, payload: any) {
    state.guestRunningEllipse = payload;
  },
  [ConversationMutation.SET_PWA_GUEST_RUNNING_ELLIPSE](state: any, payload: any) {
    state.pwaGuestRunningEllipse = payload;
  },
  [ConversationMutation.SET_FIRST_MESSAGE_FROM_GUEST](state: any, payload: string) {
    state.firstMessageFromGuest = payload;
  },
  [ConversationMutation.SET_UNREAD_MESSAGES](state: any, payload: any) {
    state.unreadMessages = payload;
  },
  [ConversationMutation.DISABLE_INCOGNITO_MODE_NOTIFICATION](state: any, payload: boolean) {
    state.disableIncognitoModeNotification = payload;
  },
  [ConversationMutation.ALREADY_NOTIFIED_INCOGNITO_MODE](state: any, payload: boolean) {
    state.alreadyNotifiedIncognitoMode = payload;
  },
  [ConversationMutation.NOTIFY_INCOGNITO_MODE](state: any, payload: boolean) {
    state.notifyIncognitoMode = payload;
  },
};
